const DOMAIN_URL = process.env.REACT_APP_DOMAIN_URL;
export const CONFIG = {
  DOMAIN: {
    URL: DOMAIN_URL,
    IMAGE_URL: `${DOMAIN_URL}/iprojects.png`,
  },
  META: {
    TITLE: "I-Projects: 인하대학교 확장 프로그램 서비스",
    DESCRIPTION:
      "인하대학교 학생들을 위한 I-Play(강의 자동 플레이어)와 I-Notice(공지사항 알림 서비스)를 제공합니다.",
    KEYWORDS: "인하대학교, I-Play, I-Notice, 강의 자동 재생, 공지사항 알림",
  },
};
